<div class="container">
  <vgim-da-offer-light
    (continueAsDA)="onContinueAsDA()"
    (continueAsIs)="onContinueWithoutDA()"
    [isTaxableAccount]="true">
    <app-feedback-survey aside class="da-offer-light-medalia"></app-feedback-survey>
  </vgim-da-offer-light>

  <div class="row">
    <section data-cy="disclaimer" class="col-md-7 taxes-disclaimers-wrapper">
      <div class="c11n-text-sm taxes-disclaimers-wrapper">
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part1"></span>
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part2"></span>
        <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'" [href]="openChoiceCommonContent.disclaimer.linkHref">{{ openChoiceCommonContent.disclaimer.linkText }}</a>
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part3"></span>
        <span [innerHTML]="content.offerDisclaimer"></span>
      </div>
    </section>
  </div>
  <onb-mfe-secure-link></onb-mfe-secure-link>
</div>
